import {
    Navigate,
    Route,
    Routes,
} from 'react-router-dom';

import {IndexPage} from './pages/IndexPage';
import {AddPage} from './pages/AddPage';
import {EditPage} from './pages/EditPage';
import {useVerifiedPermissions} from "../../hooks/useVerifiedPermissions.ts";

export const MessagesLayout = () => {

    const {allowedActions} = useVerifiedPermissions()


    return (
        <Routes>
            <Route
                path='/'
                element={
                    allowedActions.includes('ListMessages') ? (
                        <IndexPage/>
                    ) : (
                        <Navigate to='/'/>
                    )
                }
            />
            <Route
                path='tag/:tag'
                element={
                    allowedActions.includes('ListMessages') ? (
                        <IndexPage/>
                    ) : (
                        <Navigate to='/'/>
                    )
                }
            />
            <Route
                path='status/:status'
                element={
                    allowedActions.includes('ListMessages') ? (
                        <IndexPage/>
                    ) : (
                        <Navigate to='/'/>
                    )
                }
            />
            <Route
                path='add'
                element={
                    allowedActions.includes('CreateMessage') ? (
                        <AddPage/>
                    ) : (
                        <Navigate to='/messages'/>
                    )
                }
            />
            <Route
                path=':id'
                element={
                    allowedActions.includes('GetMessage') ? (
                        <EditPage/>
                    ) : (
                        <Navigate to='/messages'/>
                    )
                }
            />
        </Routes>
    );
};
